import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { EApplicationStore } from '@enums';

import { AppStat } from '@common/utils/AppStat';

import { Icon } from '@components/Icon';

import {
	IconStoreApple,
	IconStoreAppleFilled,
	IconStoreAppleMonochrome,
	IconStoreGoogle,
	IconStoreGoogleFilled,
	IconStoreGoogleMonochrome,
	IconStoreHuawei,
	IconStoreHuaweiFilled,
	IconStoreHuaweiMonochrome,
} from '@icons';

import { EStoreIconType } from './enums';

import { IStoreIconProps } from './types';

import * as s from './StoreIcon.scss';

export const StoreIcon = (props: IStoreIconProps) => {
	const { className, type, isFilled, isMonochrome, from } = props;
	const { urls: { stores: {
		appStore: appStoreUrl,
		googlePlay: googlePlayUrl,
		huaweiAppGallery: huaweiAppGalleryUrl,
	} } } = getConfig();
	const isAppStore = type === EStoreIconType.APP_STORE;
	const isHuaweiAppGallery = type === EStoreIconType.HUAWEI_APP_GALLERY;
	const url = isAppStore
		? appStoreUrl
		: isHuaweiAppGallery
			? huaweiAppGalleryUrl
			: googlePlayUrl;
	const glyph = isAppStore
		? (isMonochrome ? IconStoreAppleMonochrome : isFilled ? IconStoreAppleFilled : IconStoreApple)
		: isHuaweiAppGallery
			? (isMonochrome ? IconStoreHuaweiMonochrome : isFilled ? IconStoreHuaweiFilled : IconStoreHuawei)
			: (isMonochrome ? IconStoreGoogleMonochrome : isFilled ? IconStoreGoogleFilled : IconStoreGoogle);
	const store = isAppStore
		? EApplicationStore.APP_STORE
		: isHuaweiAppGallery
			? EApplicationStore.HUAWEI_APP_GALLERY
			: EApplicationStore.GOOGLE_PLAY;

	const onLickClick = () => {
		AppStat.log.stores.storeOpen({ from, store });
	};

	return (
		<a
			className={cn(s.block, className, {
				[s.monochrome]: isMonochrome,
				[s.monochromeApple]: isMonochrome && store === EApplicationStore.APP_STORE,
				[s.monochromeGoogle]: isMonochrome && store === EApplicationStore.GOOGLE_PLAY,
				[s.monochromeHuawei]: isMonochrome && store === EApplicationStore.HUAWEI_APP_GALLERY,
			})}
			href={url}
			target="_blank"
			rel="noopener noreferrer"
			onClick={onLickClick}
		>
			<Icon
				className={s.icon}
				glyph={glyph}
			/>
		</a>
	);
};
